import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, OccEndpointsService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomPdpService } from "src/app/custom-pdp/custom-pdp.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';
import { CustomAddToCartService } from "../../custom-add-to-cart.service";


@Component({
  selector: 'app-product-details',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
  @Input() public productDetails;
  @Input() public standardCartCode;
  @Input() public unitSection;
  @Input() public shipToLocIDArr;
  description: any;
  monograph: any;
  monographLink: any;
  itemAddedQuantity: any;
  baseUrl: string;
  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  userDetails: any;
  cartId: any;
  cartItems: any;
  volumePrices: any;
  prodCodeSub: Subscription;
  pdpCartItemsSub: Subscription;
  allCartItemSub: Subscription;
  cartDetailsSub: Subscription;
  createdCartSub: Subscription;
  updatedCartDetailsSub: Subscription;
  images: any;
  panelProductExpanded = false;
  panelProductExpanded2 = false;
  panelProductExpanded3 = false;
  searchValue = "";
  isClicked = false;
  isValidInput = false;
  calculatedValue: any;
  buttonDisable = true;
  baseSiteId: any;
  gallery: any[];
  constructor(private readonly addToCart: CustomAddToCartService,
    private readonly modalService: NgbModal,
    private readonly pdpService: CustomPdpService,
    private readonly user: UserAccountFacade,
    private readonly sanitizer: DomSanitizer,
    private readonly occEndPoint: OccEndpointsService,
    private readonly baseSiteService: BaseSiteService,
    private readonly cd: ChangeDetectorRef,
    private readonly router: Router) { }

  ngOnInit(): void {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.pdpService.productCode.next(false);
    this.pdpService.getPDPCategory(this.productDetails?.product?.code);
    let imagesFormat = _.clone(
      _.findWhere(this.productDetails?.product?.images, { format: 'product' })
    );
    if (imagesFormat)
      imagesFormat.url = this.baseUrl + imagesFormat?.url;
    this.images = { PRIMARY: imagesFormat };
    this.prodCodeSub = this.pdpService.productCode$.subscribe((res) => {
      if (res) {
        this.volumePrices = res?.volumePrices;
      } else {
        this.volumePrices = [];
      }
      this.gallery = [];
      this.gallery.push(res.images?.GALLERY);
      this.cd.detectChanges();
    });
    this.description = this.productDetails?.product?.description;
    this.monograph = this.productDetails?.product?.productDocuments;
    if (this.monograph) {
      for (const link of this.monograph?.productDocument) {
        this.monographLink = this.sanitizer.bypassSecurityTrustResourceUrl(link.url);
      }
    }
    this.user.get().subscribe((res) => {
      if (res) {
        this.userDetails = res;
        if (this.userDetails) {
          this.pdpService.getCarts(this.userDetails?.userName);
        }
      }
    });
    this.pdpCartItemsSub = this.pdpService.cartItems$.subscribe((res) => {
      if (res) {
        this.cartDataMapping(res);
      }
    });
    this.allCartItemSub = this.addToCart.allCartItems$.subscribe((res) => {
      if (res) {
        this.cartDataMapping(res);

      }
    });
  }
  cartDataMapping(response) {
    this.cartItems = response?.carts;
    this.cartItems = this.cartItems.filter((item) => item?.saveTime === undefined);
    this.cartItems = this.cartItems[this.cartItems?.length - 1];
    this.cartId = this.cartItems?.code;
  }
  performQuantityComputation(operator, code, quantity, unit, availableQty): void {
    this.buttonDisable = false;
    ProductUtils.computeQuantityForAllocated(operator, code, quantity, unit, availableQty, true);
  }
  updateCart(idData, popover): void {
    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const params = [{ entryNumber: this.productDetails?.entryNumber, quantity: inputElement.value }];

    this.addToCart.updateCartDetails(this.standardCartCode, params, this.cartId);

    this.cartDetailsSub = this.addToCart.cartDetails$.subscribe((res: any) => {
      if (res) {
        this.successPopoverDisplay(popover);
      }
    });
  }
  close(): void {
    this.modalService.dismissAll();
    //dont want to reload on closing modal on certain pages.
    if (!this.router?.url?.includes('/orderConfirmation') && !this.router?.url?.includes('/checkout')
      && !this.router?.url?.includes('/my-account/order/') && !this.router?.url?.includes('/my-company/pending-orders')) {
      window.location.reload();
    }
  }
  addToSessionCart(idData, productCode, basePrice = 0, popover): void {
    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const params = {
      selectedLocations: this.shipToLocIDArr,
      product: {
        code: productCode,
      },
      quantity: inputElement.value,
      basePrice: {
        value: basePrice
      }
    };
    this.itemAddedQuantity = inputElement.value;


    if (this.cartItems && this.cartItems?.length === 0) {
      this.pdpService.createCart(this.userDetails?.userName);
      this.createdCartSub = this.pdpService.createdCart$.subscribe((res) => {
        if (res) {
          this.cartId = res?.code;
          this.pdpService.getCarts(this.userDetails?.userName);
          this.updateCartDetails(params, popover);
        }
      });
    } else {
      if (this.cartId === undefined) {
        this.cartItems = this.cartItems && this.cartItems?.length > 0 ? this.cartItems[this.cartItems?.length - 1] : [];
        this.cartId = this.cartItems?.code;
      }
      this.updateCartDetails(params, popover);
    }
  }
  updateCartDetails(params, popover) {
    this.pdpService.updateCart(params, this.userDetails?.userName, this.cartId, this.productDetails);
    this.updatedCartDetailsSub = this.pdpService.cartDetailsUpdate$.subscribe((res) => {
      if (res) {
        this.successPopoverDisplay(popover);
      }
    });
  }
  successPopoverDisplay(popover) {
    const num = 2500;
    popover.toggle();
    setTimeout(() => popover.close(), num);
  }
  ngOnDestroy() {
    this.prodCodeSub?.unsubscribe();
    this.prodCodeSub?.unsubscribe();
    this.pdpCartItemsSub?.unsubscribe();
    this.allCartItemSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.createdCartSub?.unsubscribe();
    this.updatedCartDetailsSub?.unsubscribe();
  }
  calculateUnit(val) {
    if (val.value == '') {
      this.isClicked = true;
      this.isValidInput = false;
      return;
    }
    else {
      if (/^[0-9]+.?[0-9]*$/.test(val.value)) {
        this.isClicked = true;
        this.isValidInput = true;
        this.calculatedValue = (val.value * 0.06).toFixed(1);
        
      } else {
        this.isClicked = true;
        this.isValidInput = false;
        return;
      }
    }
  }

  openImage(content) {
    this.modalService.open(content, {
      windowClass: 'carousel-modal',
    });
  }
  closePopup() {
    this.modalService.dismissAll();
  }

  get showRestrictionPopoverFor() {
    return ProductUtils.showLimitationPopoverFor;
  }

  toggleAll() {
    this.panelProductExpanded = !this.panelProductExpanded;
    this.panelProductExpanded2 = !this.panelProductExpanded2;
    this.panelProductExpanded3 = !this.panelProductExpanded3;
  }

}